import Popup from './popup';

class UnclosablePopup extends Popup {
  _getPopupSelector() {
    return '#fm-popup-multistep';
  }

  // we started to allow to close on clicking outside the popup
  // _initPopupClick() {
  //   // overrides parent method, we don't need any init here
  // }
}

export default UnclosablePopup;
